import MainLayout from "@/layout/MainLayout.vue";
export default [
  {
    path: "/student",
    component: MainLayout,
    name: "student",
    redirect: "/student/pageList",
    meta: {
      title: "学生管理",
      icon: "team",
    },
    hideChildrenInMenu: true,
    children: [
      {
        path: "/student/pageList",
        name: "studentList",
        component: () => import("@/views/Student"),
        meta: {
          title: "学生管理",
        },
      },
    ],
  },
];
